import React, { useCallback, useState, Fragment } from 'react';
import Button from '../../../../../components/Button';
import CountOfTotal from '../../../../../components/CountOfTotal';
import BaseForm from '../../../../../components/form/BaseForm';
import TextAreaForm from '../../../../../components/form/TextAreaForm';
import Select from '../../../../../components/input/Select/Select';
import Panel from '../../../../../components/outline/Panel';
import {
  MAXIMUM_NUMBER_OF_RECOMMEND_STORE_ITEM_COUNT,
  MAXIMUM_NUMBER_OF_RECOMMEND_STORE_MEMO,
  MINIMUM_NUMBER_OF_RECOMMEND_STORE_ITEM_COUNT,
  RECOMMEND_STORE_TYPE_SELECT_LIST,
  RECOMMEND_STORE_TYPE_TEXT,
  RECOMMEND_STORE_TYPE,
} from '../../../../../constants/service/app/recommendStoreConstants';
import recommendStoreSearchInfo from '../../../../../static/images/recommend/store/recommend-store-search-info.png';
import recommendStoreFilterInfo from '../../../../../static/images/recommend/store/recommend-store-filter-info.png';
import RecommendSearchInfoDrawer from '../../../common/RecommendSearchInfoDrawer';
import './RecommendStoreSaveInfo.scss';

const RecommendStoreSaveInfo = (props) => {
  const { form, setData, recommendStoreInfo, typeDisabled, resetSubText } = props;
  const { type, memo } = recommendStoreInfo;

  const [drawerVisible, setDrawerVisible] = useState(false);

  const toggleDrawerVisible = useCallback(() => {
    setDrawerVisible(!drawerVisible);
  }, [drawerVisible]);

  return (
    <Panel className="recommend-store-save-info">
      <div className="panel-header">
        <div className="title">추천 브랜드 정보</div>
        <Button isRadius color="primary" text="설명보기" onClick={toggleDrawerVisible} />
      </div>

      <div className="panel-body">
        {/* 추천 브랜드 타입 */}
        <BaseForm
          label="추천 타입"
          content={
            <Select
              list={RECOMMEND_STORE_TYPE_SELECT_LIST}
              onChange={(value) => {
                setData({
                  path: ['recommendStoreSave', 'recommendStoreInfo', 'type'],
                  value,
                });

                if (type === RECOMMEND_STORE_TYPE.PRODUCT_FILTER_RECOMMEND) resetSubText();
              }}
              defaultValue={type}
              value={type}
              disabled={typeDisabled}
              isTable={false}
            />
          }
        />

        {/* 메모 */}
        <TextAreaForm
          form={form}
          label={
            <span>
              메모
              <CountOfTotal content={memo} maxCnt={MAXIMUM_NUMBER_OF_RECOMMEND_STORE_MEMO} />
            </span>
          }
          initialValue={memo}
          maxLength={MAXIMUM_NUMBER_OF_RECOMMEND_STORE_MEMO}
          onChange={(value) =>
            setData({
              path: ['recommendStoreSave', 'recommendStoreInfo', 'memo'],
              value,
            })
          }
          name="memo"
          autoSize={{ minRows: 4, maxRows: 8 }}
        />
      </div>

      <RecommendSearchInfoDrawer
        title={`추천 브랜드 - ${RECOMMEND_STORE_TYPE_TEXT[type]}`}
        visible={drawerVisible}
        onClose={toggleDrawerVisible}
        imgUrl={type === RECOMMEND_STORE_TYPE.SEARCH_RECOMMEND ? recommendStoreSearchInfo : recommendStoreFilterInfo}
      >
        <Fragment>
          <div>*앱에서 브랜드 검색 탭에서 추천되는 브랜드 리스트입니다.</div>
          <div>
            *추천 브랜드 리스트는 최소 {MINIMUM_NUMBER_OF_RECOMMEND_STORE_ITEM_COUNT}개, 최대{' '}
            {MAXIMUM_NUMBER_OF_RECOMMEND_STORE_ITEM_COUNT}개입니다.{' '}
          </div>
        </Fragment>
      </RecommendSearchInfoDrawer>
    </Panel>
  );
};

export default RecommendStoreSaveInfo;
